import { afterEach, beforeEach, describe, expect, it, vi } from 'vitest';

import { CARD_CATEGORIES } from '../../../../../shared/cardConfig/constants';
import { PAGE_ROUTES } from '../../../../../utils/constants';
import * as hooksLib from '../../../../../utils/hooksLib';
import { type Card, getShipToCardsForReviewPage, type Page,templateMap } from './create';

describe('Template Configuration', () => {
  describe('getShipToCardsForReviewPage', () => {
    const mockSubtitle = 'Mock Subtitle';

    beforeEach(() => {
      vi.spyOn(hooksLib, 'getShipToSubtitle').mockReturnValue(mockSubtitle);
    });

    afterEach(() => {
      vi.restoreAllMocks();
    });

    it('returns correct structure for single shipTo', () => {
      const store = {
        customer: {
          shipTo: [{ address: { city: 'Test City' } }]
        }
      };

      const result = getShipToCardsForReviewPage({ store });

      expect(result).toHaveLength(1);
      expect(result[0]).toMatchObject({
        title: 'tabTitles.ship to',
        count: 1,
        subtitle: mockSubtitle
      });

      expect(Array.isArray(result[0].cards)).toBe(true);
    });

    it('filters invoiceDelivery card for second shipTo', () => {
      const store = {
        customer: {
          shipTo: [{ address: {} }, { address: {} }]
        }
      };

      const result = getShipToCardsForReviewPage({ store });

      expect(result).toHaveLength(2);

      const firstCards = result[0].cards;
      const secondCards = result[1].cards;

      const firstHasInvoice = firstCards.some(
        (card: Card) => card.key === CARD_CATEGORIES.invoiceDelivery
      );

      const secondHasInvoice = secondCards.some(
        (card: Card) => card.key === CARD_CATEGORIES.invoiceDelivery
      );

      expect(firstHasInvoice).toBe(true);
      expect(secondHasInvoice).toBe(false);
    });
  });

  describe('templateMap structure', () => {
    it('contains customer_set_up template', () => {
      expect(templateMap.customer_set_up).toBeDefined();
      expect(Array.isArray(templateMap.customer_set_up.pages)).toBe(true);
    });

    it('customer_set_up contains expected routes', () => {
      const pages = templateMap.customer_set_up.pages;
      const routes = pages.map(page => page.route);

      expect(routes).toContain(PAGE_ROUTES.company);
      expect(routes).toContain(PAGE_ROUTES.shipTo);
      expect(routes).toContain(PAGE_ROUTES.financial);
      expect(routes).toContain(PAGE_ROUTES.review);
    });

    it('contains bill_to, payer, ship_to, sold_to templates', () => {
      expect(templateMap.bill_to).toBeDefined();
      expect(templateMap.payer).toBeDefined();
      expect(templateMap.ship_to).toBeDefined();
      expect(templateMap.sold_to).toBeDefined();
    });

    it('financial page has validateFinancials flag', () => {
      const financialPage = templateMap.customer_set_up.pages.find(
        page => page.route === PAGE_ROUTES.financial
      ) as Page;

      expect(financialPage.validateFinancials).toBe(true);
      expect(Array.isArray(financialPage.cards)).toBe(true);
    });
  });
});
